export default __webpack_public_path__ + "static/media/Check.10a96053.svg";